import React from "react";
import ItemBulkEditHeader from "./ItemBulkEditHeader";
import ItemBulkEditRows from "./ItemBulkEditRows";

function ItemBulkEditContent({
  t,
  employees = [],
  useTimeBank = false,
  mustWait = false,
  control,
  getValues,
  trigger,
  formState,
  onSelectAll,
  allSelected,
  setValue,
  canSeeEmployeFolder,
  isNotDeniedEmployer,
  haveAccessFolderEnterprise,
  showError,
  showWarning,
  isActiveBankingInformationAndInsuranceAccess,
  watch,
  globalMaxAdvantageTypes,
  hiddenColumns
}) {

  return (
    <div className="arh-mb-2 arh-space-y-6 arh-bg-white arh-px-7">
      <div className="arh-overflow-auto arh-w-full">
        <div
          className="arh-w-full"
          style={{
            maxHeight: "calc(100vh - 200px)",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            height: "100vh",
          }}
        >
          <table className="arh-font-poppins arh-border-collapse arh-w-full arh-table-auto">
            <thead className="arh-bg-greyColor arh-sticky arh-top-0 arh-z-10">
              <ItemBulkEditHeader
                employees={employees}
                useTimeBank={useTimeBank}
                onSelectAll={onSelectAll}
                allSelected={allSelected}
                mustWait={mustWait}
                maxAdvantageTypes={globalMaxAdvantageTypes}
                hiddenColumns={hiddenColumns}
              />
            </thead>
            <tbody>
              {employees?.map((employee, index) => (
                <ItemBulkEditRows
                  t={t}
                  key={employee._id}
                  employee={employee}
                  employeeIndex={index}
                  useTimeBank={useTimeBank}
                  mustWait={mustWait}
                  control={control}
                  getValues={getValues}
                  trigger={trigger}
                  isSubmitted={formState?.isSubmitted}
                  setValue={setValue}
                  canSeeEmployeFolder={canSeeEmployeFolder}
                  isNotDeniedEmployer={isNotDeniedEmployer}
                  haveAccessFolderEnterprise={haveAccessFolderEnterprise}
                  showError={showError}
                  showWarning={showWarning}
                  isActiveBankingInformationAndInsuranceAccess={isActiveBankingInformationAndInsuranceAccess}
                  watch={watch}
                  maxAdvantageTypes={globalMaxAdvantageTypes}
                  hiddenColumns={hiddenColumns}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ItemBulkEditContent;
